<!--
 * @Description: 平账组件
 * @Author: sunhuihong
 * @Date: 2022-07-31 16:43:52
 * @LastEditTime: 2023-11-27 14:26:01
-->
<template>
  <el-dialog width="570px" title="平账" :visible.sync="visible" :close-on-click-modal="false"
    :before-close="handleCancel" @open="initData" center append-to-body>
    <el-form class="balance-account-form" ref="balanceAccountForm" 
      label-position="top" :rules="rules" :model="balanceAccountForm">
      <el-row :gutter="30" type="flex" justify="space-between"> 
        <el-col :span="12">
          <el-form-item prop="institutionId" label="所属机构:" >        
		     	<el-select v-model="balanceAccountForm.institutionId" clearable filterable size="small"	placeholder="请输入/选择机构" 
            :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList', srcInstitutionList, this))"
					  @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible, 'institutionList', srcInstitutionList, this)" 
            style="width: 240px;" >
		     		<el-option v-for="item in institutionList" :key="item.id" :label="item.name" :value="item.id">
		     		</el-option>
		     	</el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="amountYuan" label="金额(元):" > 
			    	<el-input v-model="balanceAccountForm.amountYuan" size="small" clearable style="width:240px" placeholder="请输入金额" 
              @input="inputAmount()"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="width: 100%;" label="平账说明:" prop="remark">
        <el-input style="width: 100%;" v-model="balanceAccountForm.remark" placeholder="请输入平账说明"  type="textarea" 
          maxlength="100" :rows="6"  />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button  type="primary" @click="handleSubmit('balanceAccountForm')">保 存</el-button>
    </div>
  </el-dialog>   
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'BalanceAccount',
  props : ["visible", "operate", "balanceId"],
  components:{
  },

  data() {
    return {
      balanceAccountForm : {},
      institutionList: [],
      srcInstitutionList: [],
      rules : {
        institutionId: [{ required: true, message: '请选择机构', trigger: 'change' }],
        amountYuan: [{ required: true, message: '请输入平账金额', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入平账说明', trigger: 'blur' }],
      }
    }
  },
  
  methods:{
		openDialog() {
			this.clearData();
			this.initData();
		},

    initData() {
			let url = this.operate == 'add' ? Constant.URL_GET_STATEMENT_DO4ADD : Constant.URL_GET_STATEMENT_DO4UPDATE;
			let params = this.operate == 'add' ? {} : {id: this.balanceId};
      let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams(params,
        Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: url,
        param: esParam,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
				if (result == null) {
          return;
        }
        this.institutionList = result.data.simpleInstitutionList;
        this.srcInstitutionList = result.data.simpleInstitutionList;
				this.balanceAccountForm = result.data;
        if(this.operate == 'add') {
          this.clearData();
        }
			})
    },

		//输入金额，只能输入数字，最长10位
		inputAmount() {
			this.balanceAccountForm.amountYuan = this.balanceAccountForm.amountYuan.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
			if (this.balanceAccountForm.amountYuan > 10) {
        this.balanceAccountForm.amountYuan = this.balanceAccountForm.amountYuan.slice(0,10);
      }
		},

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    },

    //确认
    handleSubmit() {
      this.$refs.balanceAccountForm.validate((valid) => {
        if (!valid) return;
        let url = (this.operate == 'add') ? Constant.URL_SAVE_STATEMENT : Constant.URL_UPDATE_STATEMENT;
				let method = (this.operate == 'add') ? 'POST' : 'PUT';
        let form = {
          'amountYuan' : this.balanceAccountForm.amountYuan,
          'institutionId' : this.balanceAccountForm.institutionId,
          'remark' : this.balanceAccountForm.remark,
          'id' : this.operate == 'add' ? '' : this.balanceId
        };
			  let [header, esParam] = this.encryptionUtil.encryptAndSignBody(form,
			  	Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
			  	Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: method,
          url: url,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_JSON,
        };
				this.vueRequest(requestData).then(result => {
					if (result != null) {
						this.clearData();
						this.$emit("close-dialog", true);
					}
				})	 
      })   
    },

		clearVaild() {
			this.$nextTick(() => {
				this.$refs["balanceAccountForm"].clearValidate();
			});
		},

	  //清空表单
	  clearData() {
	  	this.clearVaild();
	  	this.balanceAccountForm = {};
	  },
    
  },
}
</script>

<style >
.balance-account-form {
  padding: 0 25px;
}
.balance-account-form label{
  padding: 0 !important;
}
</style>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/finance/components/statementlist/BalanceAccount.vue